module.exports = __webpack_public_path__ + "static/img/Bg.25e1d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/Bg.png
// module id = SAps
// module chunks = 0